module.exports = [{"stylers":[{"hue":"#007fff"},{"saturation":89}]},{"featureType":"water","stylers":[{"color":"#ffffff"}]},{"featureType":"administrative.country","elementType":"labels","stylers":[{"visibility":"off"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/controllers/alerts/components/maps/geo-map/default.json
// module id = 1197
// module chunks = 0